import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// COMPONENTS
import Swimlanes from '@/components/Swimlanes';

// STYLES
import { Container } from '../../styles';

function currentlyLoading(loadingsData) {
  const loadingsArray = Object.keys(loadingsData);

  if (loadingsArray.length) {
    let hasLoading = false;

    loadingsArray.forEach(loadItem => {
      if (loadingsData[loadItem]) hasLoading = true;
    });

    return hasLoading;
  }

  return false;
}

const OtherApps = props => {
  const { data, loadings, analyticsLocation, onUpdateStatus } = props;

  const hasContent = Boolean(Object.keys(data).length);
  const curLoading = currentlyLoading(loadings);

  const hasMostPop = React.useMemo(() => {
    for (const item of Object.values(data)) {
      if (item.type === 'most_popular_on_app') return true;
    }

    return false;
  }, [data]);

  if ((!curLoading && !hasContent) || !hasMostPop) return null;

  return (
    <div>
      <Container
        className={clsx(
          'page-content other-apps-container',
          hasMostPop && 'other-apps-container--has-most-pop',
        )}
      >
        <Swimlanes
          className="app-page__collection"
          data={data}
          loadings={loadings}
          loadingRows={2}
          analyticsLocation={analyticsLocation}
          handleUpdateAppStatus={onUpdateStatus}
        />
      </Container>
    </div>
  );
};

OtherApps.propTypes = {
  data: PropTypes.object.isRequired,
  loadings: PropTypes.object.isRequired,
  analyticsLocation: PropTypes.string.isRequired,
  onUpdateStatus: PropTypes.func.isRequired,
};

export default React.memo(OtherApps);
